// extracted by mini-css-extract-plugin
module.exports = {"root":"_2btfs","section":"GlcAm","carouselContainer":"_3h3wn","bottomTextWrapper":"_1ZNNg","bottomTitle":"_1lY0F","link":"-npGk","errorMessage":"_2AIty"};